import { fetchApi } from "../../config/fetchConfig";

const submitSucess = (data) => {
    return {
        type: "SUBMIT_SUCCESS",
        payload: {
            data,
        },
    };
};
const submitError = (data) => {
    return {
        type: "SUBMIT_ERROR",
        payload: {
            data,
        },
    };
};

export const auditNoteSubmit =
    ({ projectId, fiscalYear, auditNote, modulePrefix }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($i:AuditNoteInput!,$projectId:String!,$fiscalYear:String!,$modulePrefix:String){audit_note(projectId:$projectId,fiscalYear:$fiscalYear,auditNote:$i,modulePrefix:$modulePrefix){id,status}}`,
            variables: {
                i: auditNote,
                projectId,
                fiscalYear,
                modulePrefix,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data.audit_note.status || {};
                if (data === 201 || data === 200) {
                    dispatch(submitSucess(auditNote.findingId));
                } else {
                    dispatch(submitError(auditNote.findingId));
                }
            })
            .catch((e) => {
                dispatch(submitError(auditNote.findingId));
            });
    };
